export type StatusColor = 'green' | 'amber' | 'red' | 'blue' | 'grey';

const STATUS_COLORS: Record<string, StatusColor> = {
  PENDING: 'amber',
  PREPARING: 'blue',
  INVITED: 'blue',
  SUBMITTED: 'blue',
  APPROVED: 'green',
  ACTIVE: 'green',
  ACCEPTED: 'green',
  CONFIRMED: 'green',
  SUCCESS: 'green',
  SENT: 'green',
  REJECTED: 'red',
  DECLINED: 'red',
  TRACE_FAILED: 'red',
  FAILED: 'red',
  FAILURE: 'red',
  CANCELLED: 'red',
  REVOKED: 'red',
  SUSPENDED: 'grey',
  REMOVED: 'grey',
  EXPIRED: 'grey',
};

export function statusColor(status: string): StatusColor {
  return STATUS_COLORS[status.toUpperCase()] ?? 'grey';
}
